// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"bfacb8bd","498":"ea86f609","513":"cd66512c"}[chunkId] + ".chunk.js";
};